module.exports = __webpack_public_path__ + "b0b8fa7542d35210d4df8a6d7c3de7a0.svg";